import { useQuery } from "@tanstack/react-query";

import { getExtendedDocumentData } from "AdvisoryManagement/Api/Queries/useContractsQuery";
import {
	DocumentExpandFields,
	type DocumentResponse,
	getDocumentsId,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import keys from "../keys";

export const useDocumentQuery = (documentId?: string) => {
	return useQuery({
		queryKey: keys.documentDetail(documentId),
		queryFn: processResponse(() =>
			getDocumentsId(documentId!, [DocumentExpandFields.DocumentData]),
		),
		select: (data: DocumentResponse) => getExtendedDocumentData(data),
		enabled: !!documentId,
	});
};
